import { render, staticRenderFns } from "./ModalLaboError.vue?vue&type=template&id=551e84af&lang=html&"
import script from "./ModalLaboError.vue?vue&type=script&lang=js&"
export * from "./ModalLaboError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ModalLaboError.vue"
export default component.exports